export default "__VITE_ASSET__I7Vfwg7P__"